module.exports = __webpack_public_path__ + "assets/img/ef68-sm.svg";